module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/eyecatch-problem-02-afd0d2315e3265986af19d780b8f59e2.png";